import { type GridColumn } from "@common/controls/Grid/types";
import GridView, { type GridViewProps } from "@common/controls/GridView/component";
import { useI18n } from "@common/hooks/i18n";
import { sort } from "@common/lib/array";
import { formatMoneyDisplay } from "@common/lib/format";
import Network from "@common/modules/network/types";
import * as React from "react";

type CommissionVolumeContactDrillDownGridProps = {
  data: Network.CommissionRules.Api.CommissionVolume[];
  userId: number;
};

export const CommissionVolumeContactDrillDownGrid = (props: CommissionVolumeContactDrillDownGridProps) => {
  const i18n = useI18n();

  const volumeDrillDownGridData = React.useMemo((): GridViewProps<
    Network.CommissionRules.Api.CommissionVolume,
    Network.CommissionRules.Api.CommissionVolume
  > => {
    const items = props.data.filter((x) => x.userId === props.userId);

    const columns: GridColumn<Network.CommissionRules.Api.CommissionVolume>[] = [
      {
        key: "commissionRuleName",
        name: i18n.commissionName,
        dataType: "string",
        qa: "Commission name"
      },
      {
        key: "volume",
        name: i18n.amount,
        dataType: "string",
        data: (x) => formatMoneyDisplay(x.volume, x.currencyCode),
        qa: "Amount"
      }
    ];

    return {
      idKey: "userId",
      columns: columns,
      data: sort(items, { key: "commissionRuleName" }),
      isLoading: false,
      toolbar: {
        showAdd: false,
        showSearch: false
      }
    };
  }, [i18n, props.data, props.userId]);

  return <GridView pageSize={10} {...volumeDrillDownGridData} idKey="userId" isLoading={false} useSearchUrl={false} />;
};
